import React from 'react'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import { LoadingSpinner } from 'shared'

// TODO: to be set as an env var or moved somewhere safer
const REACT_APP_GOOGLE_API = 'AIzaSyC9iWmI7mU7g9_11IQwj-ExKSe7K9dkfsc'

interface MapProps {
	lat: string
	long: string
}

const Map = ({ lat, long }: MapProps) => {
	const latitude = parseFloat(lat)
	const longitude = parseFloat(long)

	const { isLoaded } = useLoadScript({
		googleMapsApiKey: REACT_APP_GOOGLE_API,
	})
	const center = { lat: latitude, lng: longitude }

	const mapStyles = {
		height: '150px',
		overflow: 'hidden',
	}

	if (!isLoaded) {
		return <LoadingSpinner />
	}
	return (
		<div className="mapContainer">
			{
				<GoogleMap
					mapContainerStyle={mapStyles}
					center={center}
					zoom={15}>
					<Marker position={center} />
				</GoogleMap>
			}
		</div>
	)
}

export default Map
